import type { ThemeOptions } from '@mui/material/styles';

export const fontFamily = [
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'sans-serif',
].join(', ');

export const fontFamilyMono = ['JetBrains Mono', 'IBM Plex Mono', 'ui-monospace', 'monospace'].join(', ');

/** Weights stop at 600. Body copy stays at 400. */
export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
} as const;

export const typographyOptions: ThemeOptions['typography'] = {
  fontFamily,
  fontWeightRegular: fontWeight.regular,
  fontWeightMedium: fontWeight.medium,
  fontWeightBold: fontWeight.semibold,
  h1: { fontSize: '1.25rem', fontWeight: fontWeight.semibold, lineHeight: 1.25, letterSpacing: '-0.01em' },
  h2: { fontSize: '1.125rem', fontWeight: fontWeight.semibold, lineHeight: 1.3 },
  h3: { fontSize: '1rem', fontWeight: fontWeight.semibold, lineHeight: 1.35 },
  h4: { fontSize: '0.875rem', fontWeight: fontWeight.semibold, lineHeight: 1.4 },
  h5: { fontSize: '0.875rem', fontWeight: fontWeight.semibold, lineHeight: 1.4 },
  h6: { fontSize: '0.8125rem', fontWeight: fontWeight.semibold, lineHeight: 1.4 },
  subtitle1: { fontSize: '0.875rem', fontWeight: fontWeight.medium, lineHeight: 1.45 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: fontWeight.semibold, lineHeight: 1.45 },
  body1: { fontSize: '0.875rem', fontWeight: fontWeight.regular, lineHeight: 1.5 },
  body2: { fontSize: '0.8125rem', fontWeight: fontWeight.regular, lineHeight: 1.5 },
  caption: { fontSize: '0.75rem', fontWeight: fontWeight.regular, lineHeight: 1.4 },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: fontWeight.semibold,
    letterSpacing: '0.08em',
    lineHeight: 1.4,
    textTransform: 'uppercase',
  },
  button: {
    fontSize: '0.8125rem',
    fontWeight: fontWeight.semibold,
    lineHeight: 1.4,
    textTransform: 'none',
    letterSpacing: 0,
  },
};
